<template>
<div class="contrast">
  <div class="contrast-title" v-if="cItem.hide_title == 0">
    <img :src="static_img_url + 'pic/module_tct_icon.png'" />{{cItem.title}}
  </div>
  <div class="contrast-summary" v-html="cItem.summary"></div>
  <div style="position: relative; overflow: hidden">
    <div class="contrast-left-nav">
      <div class="left-nav-top">地区/分类</div>
      <div class="left-nav" >
        <div v-for="item in cItem.content.y" :key="item">{{item | dealName(meta.address)}}</div>
      </div>
    </div>
    <CheckboxGroup class="contrast-ctcs" v-model="annotation_tag_list">
      <div class="contrast-content2">
        <div class="contrast-left">
          <div class="head-1">地区/分类</div>
          <div class="label-tag" v-for="item in cItem.content.y">{{item | dealName(meta.address)}}</div>
        </div>
        <div class="contrast-ctc" v-for="item,index in new_annotation_tag" :key="index">
          <div :class="'f_tag chk'+(index+1)">
            <Checkbox :label="item.id">
              <span>{{item.name}}</span>
            </Checkbox>
          </div>
          <div class="ctc-items">
            <div class="axis-list">
              <div
                class="axis"
                v-for="item2,index2 in item.children"
                :key="index2"
                v-if="annotation_tag_list.findIndex((a) => a == item2.pid) > -1"
              >
                <span>{{item2.name}}</span>
              </div>
            </div>
            <div
              class="ctc-item"
              v-for="item3,index3 in cItem.content.y"
              :key="index3"
            >
              <div class="ctc-y"
                v-for="item2,index2 in item.children"
                :key="index2"
                v-if="annotation_tag_list.findIndex((a) => a == item2.pid) > -1"
              >
                <span class="bg-font">{{item2.name}}</span>
                <Tooltip
                  :placement="tooltip_placement(index, new_annotation_tag.length, index2, item.children.length)"
                  v-for="item4,index4 in cItem.content.res"
                  :key="index4"
                  v-if="item4.address_id == item3 && item4.tag_id == item2.id"
                >
                  <span
                    class="spa1"
                    :style="{'width': '30px', 'background-color' : colors[index] || 'rgba(250, 122, 80, 1)'}"
                    @click="handleClickItem(item4)"
                  ></span>
                  <div slot="content" @click="handleClickItem(item4)">
                    <p class="p1">{{item3 | dealName(meta.address)}}（共{{item4.ca_num}}起）</p>
                    <p class="p2">
                      <i :style="{'background-color': colors[index] || 'rgba(250, 122, 80, 1)'}"></i>{{item2.name}}
                    </p>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckboxGroup>
  </div>
  <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
  <div class="spa">
    <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid)" @on-popper-hide="handleShareHide">
      <i class="iconfont">&#xe641;</i>
      <div slot="content" class="share_cnt clear">
        <div class="share_img"></div>
        <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
      </div>
    </Poptip>
  </div>
  <Modal
    v-model="detail_modal"
    class="detail-modal"
    width="500"
    @on-visible-change="list_show_index = []"
    >
    <div slot="header">{{modal_address | dealName(meta.address)}}(共{{policy_list.length}}起)</div>
    <div class="list">
      <div v-for="item,index in policy_list" :key="index">
        <i class="iconfont">&#xe62b;</i>
        <div class="li-top">
          <span @click="goPolicyDetail(item)">{{item.name}}</span>
        </div>
        <div class="li-cnt" v-if="item.content">
          {{item.content.length > 100 && !list_show(index) ?  item.content.substr(0, 100).concat('...') : item.content }}
          <span v-if="item.content.length > 100" @click="haddleClickShow(index)">{{list_show(index) ? '收起' : '展开'}}</span>
        </div>
        <div class="li-bto">
          <span>{{item.publish_time | time_moment}}</span>
          <span>{{item.publish_org}}</span>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button @click="detail_modal = !detail_modal">知道了</Button>
    </div>
  </Modal>
</div>
</template>
<script>
import { policyAnnotation } from '../../../service'
export default {
  props: ['cItem', 'paramsUid', 'meta'],
  data() {
    return {
      colors: ['#E96350','#FFCB6A','#A6D911','#36CFC9','#40A9FF','#F88C52','#FFCCBC','#53C419','#1EA69B','#2F54EB'],
      annotation_tag_list: [],
      policy_list: [],
      detail_modal: false,
      modal_address: '',
      list_show_index: [],
      width_list: {}
    }
  },
  computed: {
    list_show() {
      return function(i) {
        let index = this.list_show_index.findIndex((a) => a == i)
        if (index > -1) {
          return true
        } else {
          return false
        }
      }
    },
    static_img_url() {
      return this.$store.state.static_img_url
    },
    new_annotation_tag() {
      let sec_arr = [], fir_arr = [], temp_arr = []
      this.cItem.content.x.map(item => {
        let temp = this.meta.annotation_tag.find(a => a.id == item && a.pid != null)
        if (temp) {
          sec_arr.push(temp)
        }
      })
      for (let f of sec_arr) {
        if (temp_arr.indexOf(f.pid) == -1) {
          temp_arr.push(f.pid)
          fir_arr.push(Object.assign(this.meta.annotation_tag.find(a => a.id == f.pid), {children: []}))
        }
      }
      sec_arr.map(item => {
        let index = fir_arr.findIndex(a => a.id == item.pid)
        if (index > -1) {
          fir_arr[index].children.push(item)
        }
      })
      fir_arr = JSON.parse(JSON.stringify(fir_arr))
      return fir_arr
    },
    tooltip_placement() {
      return function(idx, len, idx2, len2) {
        let p = 'top'
        if (idx == len - 1 && idx2 == len2 - 1) {
          p = 'top-end'
        }
        if (idx == 0 && idx2 == 0) {
          p = 'top-start'
        }
        return p
      }
    }
  },
  methods: {
    async handleClickItem(item) {
      this.modal_address = item.address_id
      let res = await policyAnnotation({
        ids: item.ca_ids
      }, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'policy_list', res.res)
        this.detail_modal = true
      } else {
        this.$Message.error(res.message)
      }
    },
    goPolicyDetail(item) {
      const {
        href
      } = this.$router.resolve({
        name: "PolicyDetail",
        params: {
          uid: item.uid
        }
      })
      window.open(href, '_blank')
    },
    haddleClickShow(val) {
      let index = this.list_show_index.findIndex((a) => a == val)
      if (index > -1) {
        this.list_show_index.splice(index, 1)
      } else {
        this.list_show_index.push(val)
      }
    },
    handleShare(theme_uid) {
      let share_link = window.location.protocol + '//' + window.location.host + '/mindex/shareScatter?tct_id='+this.cItem.id+'&theme_uid=' + theme_uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    }
  },
  created() {
    this.meta.annotation_tag.map((a) => {
      if (!a.pid) {
        this.annotation_tag_list.push(a.id)
      }
    })
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/constrast.stylus'
.contrast-content2
  display: flex
  position: relative;
  width: 700px;
  overflow-x: auto;
  padding-bottom: 4px;
  &::-webkit-scrollbar-track
    border: 0
    background-color: transparent
  &::-webkit-scrollbar
    height: 6px
    commonBgColor(#2A2F42, rgba(247,247,247,1))
  &::-webkit-scrollbar-thumb
    border-radius: 4px
    commonBgColor(#4c4f59, #77797a)
  .contrast-left
    >div
      font-size: 14px
      line-height: 18px
      padding: 16px
      commonColor(#E9E9EB, #666666)
      height: 50px
      &.head-1
        padding: 16px 16px 0 20px
        commonColor(#BCBDC1, #999999)
        display: flex
        align-items: center
        font-size: 12px
        height: 52px
        width: max-content
      &:nth-of-type(even)
        commonBgColor(#2A2F42, #FFFAF5)
  .contrast-ctc
    flex: 1
    .f_tag
      text-align: center
      padding: 4px 16px 0
      >>> .ivu-checkbox-wrapper
        vertical-align: top
        font-size: 0
        margin-right: 0
        padding: 0
        white-space: nowrap
        .ivu-checkbox
          font-size: 0
          vertical-align: top
          .ivu-checkbox-inner
            commonBorderColor(#7A7F94, #D5D5D5)
            background-color: transparent
          &+span
            margin-right: 0
            font-size: 13px
            display: inline-block
            line-height: 14px
            margin-left: 6px
            commonColor(#E9E9EB, #333333)
          .ivu-checkbox-focus
            box-shadow: none
          &.ivu-checkbox-checked
            .ivu-checkbox-inner
              border-color: rgba(250, 122, 80, 1)
              background-color: rgba(250, 122, 80, 1)
    .ctc-items
      margin-top: 8px
      .axis-list
        display: flex
        padding: 0 8px
        height: 26px
        justify-content: center
        .axis
          padding: 0 8px
          width: max-content
          height: 26px
          position: relative
          text-align: center
          span
            font-size: 12px
            commonColor(#BCBDC1, #999999)
          &:before
            content: ''
            position: absolute
            width: 1px
            height: 6px
            commonBgColor(#40444F, #D5D5D5)
            bottom: 4px
            left: 50%
      .ctc-item
        display: flex
        padding: 0 8px
        height: 50px
        justify-content: center
        commonBgImg('~pic/line-gray.png', '~mobile/pic/line.png')
        background-size: 100% 1px
        background-repeat: no-repeat
        background-position: 0 center
        .ctc-y
          font-size: 14px
          height: 50px
          position: relative
          padding: 0 8px
          width: max-content
          .bg-font
            font-size: 12px
            color: transparent
            opacity: 0
          .ivu-tooltip
            font-size: 0
            line-height: 1
            position: absolute
            left: 50%
            top: 50%
            cursor: pointer
            transform: translate(-50%, -50%)
            >>> .ivu-tooltip-popper
              z-index: 2
              .ivu-tooltip-arrow
                border-bottom-color: #40444F
              &[x-placement=top-start]
                transform: translateX(-2px)
                .ivu-tooltip-arrow
                  left: 12px
              &[x-placement=top-end]
                transform: translateX(2px)
                .ivu-tooltip-arrow
                  right: 12px
              .ivu-tooltip-inner
                background-color: #40444F
                padding: 8px 10px
                cursor: pointer
                .p1
                  color: #fff
                  font-size: 12px
                  line-height: 16px
                .p2
                  color: #C8C8C8
                  font-size: 12px
                  line-height: 16px
                  margin-top: 4px
                  i
                    display: inline-block
                    vertical-align: top
                    width: 8px
                    height: 8px
                    border-radius: 50%
                    margin-top: 4px
                    margin-right: 5px
            .spa1
              display: inline-block
              height: 7px
              width: 30px
        &:nth-of-type(even)
          commonBgColor2(#2A2F42, #FFFAF5)
    &+.contrast-ctc
      border-left: 1px dashed
      commonBorderColor(#40444F, #D5D5D5)
.contrast-left-nav
  position: absolute
  left: 0
  top: 0
  commonBgColor(#1F2330, #FFFFFF)
  border-right: 1px solid
  commonBorderColor(#40444F, #e9e9e9)
  z-index: 3
  commonShadow(1px 0px 5px rgba(255,255,255,.1), 1px 0px 5px rgba(0,0,0,.1))
  .left-nav-top
    padding: 16px 16px 0 20px
    commonColor(#BCBDC1, #999999)
    display: flex
    align-items: center
    font-size: 12px
    height: 52px
  .left-nav
    > div
      font-size: 14px
      line-height: 18px
      padding: 16px
      commonColor(#E9E9EB, #666666)
      &:nth-of-type(odd)
        commonBgColor(#2A2F42, #FFFAF5)
.detail-modal
  >>> .ivu-modal-wrap .ivu-modal .ivu-modal-content .ivu-modal-body .list
    max-height: 343px
    > div
      .li-bto span
        color: #999
.chk1 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #E96350 !important
  background-color: #E96350 !important
.chk2 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #FFCB6A !important
  background-color: #FFCB6A !important
.chk3 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #A6D911 !important
  background-color: #A6D911 !important
.chk4 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #36CFC9 !important
  background-color: #36CFC9 !important
.chk5 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #40A9FF !important
  background-color: #40A9FF !important
.chk6 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #F88C52 !important
  background-color: #F88C52 !important
.chk7 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #FFCCBC !important
  background-color: #FFCCBC !important
.chk8 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #53C419 !important
  background-color: #53C419 !important
.chk9 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #1EA69B !important
  background-color: #1EA69B !important
.chk10 >>> .ivu-checkbox-wrapper .ivu-checkbox-checked .ivu-checkbox-inner
  border-color: #2F54EB !important
  background-color: #2F54EB !important
</style>
